import {
  DiscoverySectionData,
  DiscoverySectionKinds,
} from 'services/store/discovery/types';
import ThemesSection from '../ThemesSection';
import MoodsSection from '../MoodsSection';
import GenresSection from '../GenresSection';

interface Props {
  section: DiscoverySectionData;
}

const DiscoverySection = ({ section }: Props) => {
  if (section.kind === DiscoverySectionKinds.GENRES) {
    return <GenresSection data={section} />;
  }
  if (section.kind === DiscoverySectionKinds.MOODS) {
    return <MoodsSection data={section} />;
  }
  if (section.kind === DiscoverySectionKinds.THEMES) {
    return <ThemesSection data={section} />;
  }
  return null;
};

export default DiscoverySection;
